/* Handwoven Heirlooms — quick delights: wishlist hearts, saved-rugs page,
   recently-viewed rail, and the macro texture lens on product photos.
   Everything is stored in localStorage on the shopper's device; no app. */
(function () {
  var WKEY = 'hw-wishlist';
  var RKEY = 'hw-recent';
  var HEART =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function imgUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ---------- wishlist hearts ---------- */
  function syncHearts(root) {
    var saved = read(WKEY);
    (root || document).querySelectorAll('[data-hw-heart]').forEach(function (b) {
      var on = saved.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener(
    'click',
    function (e) {
      var b = e.target.closest ? e.target.closest('[data-hw-heart]') : null;
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var h = b.getAttribute('data-handle');
      var list = read(WKEY);
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1);
      else list.unshift(h);
      write(WKEY, list);
      syncHearts();
      /* On the saved page, removing a heart removes the card. */
      var grid = document.querySelector('[data-hw-saved-grid]');
      if (grid && i > -1) {
        var card = b.closest('.hw-mini-card');
        if (card) card.remove();
        if (!grid.querySelector('.hw-mini-card')) renderCards(grid, [], EMPTY_SAVED);
      }
    },
    true
  );

  /* Re-sync when Dawn re-renders grids (filters, variant changes). */
  var syncTimer;
  new MutationObserver(function () {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { syncHearts(); }, 200);
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- shared mini-card renderer ---------- */
  var EMPTY_SAVED = 'No saved rugs yet. Tap the heart on any rug to keep it here.';
  function renderCards(container, handles, emptyMsg) {
    if (!handles.length) {
      container.innerHTML = '<p class="hw-mini-empty">' + emptyMsg + '</p>';
      return;
    }
    container.innerHTML = '';
    handles.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var a = document.createElement('a');
          a.className = 'hw-mini-card';
          a.href = p.url;
          a.innerHTML =
            '<span class="hw-mini-card__media"><img loading="lazy" src="' + imgUrl(p.featured_image, 480) + '" alt=""></span>' +
            '<span class="hw-mini-card__title">' + p.title.split('|')[0].trim() + '</span>' +
            '<span class="hw-mini-card__price">From ' + money(p.price) + '</span>' +
            '<button type="button" class="hw-heart hw-heart--mini" data-hw-heart data-handle="' + h + '" aria-label="Save or unsave">' + HEART + '</button>';
          container.appendChild(a);
          syncHearts(a);
        })
        .catch(function () {});
    });
  }

  /* ---------- saved-rugs page ---------- */
  var savedGrid = document.querySelector('[data-hw-saved-grid]');
  if (savedGrid) renderCards(savedGrid, read(WKEY), EMPTY_SAVED);

  /* ---------- recently viewed ---------- */
  var onProduct = location.pathname.match(/\/products\/([a-z0-9\-]+)/);
  if (onProduct) {
    var rec = read(RKEY).filter(function (h) { return h !== onProduct[1]; });
    rec.unshift(onProduct[1]);
    write(RKEY, rec.slice(0, 9));
  }
  var recentGrid = document.querySelector('[data-hw-recent-grid]');
  if (recentGrid) {
    var rh = read(RKEY)
      .filter(function (h) { return !onProduct || h !== onProduct[1]; })
      .slice(0, 4);
    var wrap = recentGrid.closest('.hw-recent');
    if (!rh.length) {
      if (wrap) wrap.style.display = 'none';
    } else {
      renderCards(recentGrid, rh, '');
    }
  }

  /* ---------- macro texture lens (desktop pointers only) ---------- */
  if (window.matchMedia('(min-width: 990px) and (pointer: fine)').matches) {
    var R = 95; /* lens radius in px */
    var ZOOM = 2.4;
    document.querySelectorAll('.product__media').forEach(function (wrap) {
      var img = wrap.querySelector('img');
      if (!img || wrap.dataset.hwLens) return;
      wrap.dataset.hwLens = '1';
      var lens = document.createElement('div');
      lens.className = 'hw-lens';
      wrap.appendChild(lens);
      wrap.addEventListener('mousemove', function (ev) {
        var r = wrap.getBoundingClientRect();
        var x = ev.clientX - r.left;
        var y = ev.clientY - r.top;
        lens.style.left = x + 'px';
        lens.style.top = y + 'px';
        lens.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
        lens.style.backgroundSize = r.width * ZOOM + 'px ' + r.height * ZOOM + 'px';
        lens.style.backgroundPosition = (R - x * ZOOM) + 'px ' + (R - y * ZOOM) + 'px';
        lens.style.opacity = '1';
      });
      wrap.addEventListener('mouseleave', function () { lens.style.opacity = '0'; });
    });
  }
})();
